// extracted by mini-css-extract-plugin
export default {"modal":"IQ-z","sharingIconsV2":"JQ-z","notificationBox":"KQ-z","checkMark":"LQ-z","textFrame":"MQ-z"};